import React, { useState } from "react";
import { Payment } from "components";
import TypePayment from "components/pay/TypePayment";
import ValidateUser from "components/pay/ValidateUser";
import Selectgateway from "components/pay/Selectgateway";
import RenderBtnPayment from "components/pay/RenderBtnPayment";
import { ReactComponent as IconWhatsapp } from "assets/icons/whatsapp-icon-logo.svg";
import ScrollToTop from "common/scroll/ScrollToTop";
import { ReactComponent as BgLines } from "assets/patterns/Textura.svg";
import { ReactComponent as Logo } from "assets/patterns/eliteVacances.svg";

const Payments = () => {
  const [user, setUser] = useState(null);
  const [mora, setMora] = useState(null);
  const [formConfig, setFormConfig] = useState({
    step: 1,
  });

  const showView = () => {
    switch (formConfig.step) {
      case 1:
        return (
          <ValidateUser
            setFormConfig={setFormConfig}
            setUser={setUser}
            setMora={setMora}
          />
        );
      case 2:
        return (
          <TypePayment
            setFormConfig={setFormConfig}
            user={user}
            setUser={setUser}
            mora={mora}
          />
        );
      case 3:
        return (
          <Payment
            user={user}
            setUser={setUser}
            mora={mora}
            setFormConfig={setFormConfig}
          />
        );
      case 4:
        return (
          <Selectgateway
            user={user}
            setUser={setUser}
            setFormConfig={setFormConfig}
          />
        );
      case 5:
        return <RenderBtnPayment user={user} setFormConfig={setFormConfig} />;

      default:
        break;
    }
  };

  return (
    <article className="container-payments-centered">
      <BgLines className="bg-icon" />

      <section className="form-container">
        <Logo className="logo-payments-elite" />
        <ScrollToTop step={formConfig.step} />
        <div className="separator mb-4">
          <hr className="line" />
          <p>Realiza tu pago</p>
          <hr className="line" />
        </div>
        <div className="container-pay">
          <img
            loading="lazy"
            src="/images/logo/logo-mercado-pago.svg"
            alt="mercado pago"
            width="150"
            height="50"
          />
          <img
            loading="lazy"
            src="/images/logo/pse-logo.png"
            alt="mercado pago"
            width="120"
            height="47"
          />
          {/* <img
          loading="lazy"
          src="/images/logo/openpay.svg"
          alt="mercado pago"
          width="180"
          height="50"
        /> */}
        </div>
        
        {showView()}

        <a
          href="https://api.whatsapp.com/send?phone=5717945996&text=Buen%20d%C3%ADa%20%20%0ARequiero%20ayuda%20para%20realizar%20mis%C2%A0pagos"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-help-whatsapp"
        >
          <IconWhatsapp />
          ¿Necesitas ayuda? Chatea con nosotros
        </a>
      </section>
    </article>
  );
};

export default Payments;
